import { call, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { UwContextKey } from '@ps20-frontend/uw';
import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';
import { WarenkorbAngebot } from '../reducers/produkte.reducer';

function hasUwEntries(produkt: WarenkorbAngebot): boolean {
  return (produkt.uw?.entries.length ?? 0) > 0;
}

export function* watchUwResubmissionFulfilledAngebote() {
  yield takeEvery(
    GlobalActions.SET_NEEDS_UW_RESUBMISSION,
    safeSaga(collectUwResubmissionFulfilledAngebote, App.SHOP_DASHBOARD),
  );
}

export function* collectUwResubmissionFulfilledAngebote(
  action: GlobalAction<{
    needsResubmission: boolean;
    angebotsId: string;
    requiredByContext?: Partial<Record<UwContextKey, boolean>>;
  }>,
) {
  if (action.payload?.needsResubmission !== true) {
    return;
  }

  const state: IAppState = yield select();
  const warenkorb = state.warenkorb || [];

  const triggeringAngebotsId = action.payload.angebotsId;
  const triggeringProdukt = warenkorb.find(
    produkt => produkt.angebotsId === triggeringAngebotsId,
  );

  const angebotsIdsToReset = warenkorb
    .filter(hasUwEntries)
    .map(produkt => produkt.angebotsId);

  if (angebotsIdsToReset.length === 0) {
    return;
  }

  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().uwResubmissionFulfilledAngeboteCollected(
      angebotsIdsToReset,
      triggeringProdukt?.appId,
      triggeringAngebotsId,
      action.payload.requiredByContext,
    ),
  );
}
